import type { GetAccountsByRetailerResponseItem } from '@packages/clients';

import type { AccountEntity } from '../entities';

/**
 * Map a backend account DTO into a domain-layer {@link AccountEntity}. Renames boolean fields
 * to match domain naming conventions (`enabled` -> `isEnabled`, `emailNotificationsEnabled` ->
 * `hasEmailNotificationsEnabled`, etc.) and ensures consumers depend on the entity type rather
 * than the raw API response shape.
 *
 * @param dto - the raw account item from the retailer search endpoint
 * @returns a domain entity representing the account
 * @example
 * ```ts
 * const entity = toAccountEntity(apiItem);
 * console.log(entity.accountId); // '3914a765-...'
 * ```
 */
export function toAccountEntity(dto: GetAccountsByRetailerResponseItem): AccountEntity {
    return {
        accountId: dto.accountId,
        accountSourceId: dto.accountSourceId,
        accountStatusId: dto.accountStatusId,
        createdAccountId: dto.createdAccountId,
        createdTimestamp: dto.createdTimestamp,
        defaultEmailAddressId: dto.defaultEmailAddressId,
        defaultPhoneNumberId: dto.defaultPhoneNumberId,
        firstName: dto.firstName,
        hasEmailNotificationsEnabled: dto.emailNotificationsEnabled,
        hasPushNotificationsEnabled: dto.pushNotificationsEnabled,
        isEnabled: dto.enabled,
        jobTitle: dto.jobTitle,
        lastName: dto.lastName,
        lastSyncedTimestamp: dto.lastSyncedTimestamp,
        lastUpdatedAccountId: dto.lastUpdatedAccountId,
        lastUpdatedTimestamp: dto.lastUpdatedTimestamp,
        locale: dto.locale,
        soaUserId: dto.soaUserId,
        soaUsername: dto.soaUsername,
        timeZone: dto.timeZone,
    };
}
